/**
 * Created by chenggong on 2018/3/30.
 */
import Cookies from 'js-cookie'

// 用户信息
const userInfo = {
  name: '测试数据',
  email: '测试数据',
  code: '',
  token: Cookies.get('token') || '',
  department_code: '',
  department_list: [],
  seclevel: 0
}

const searchData = {
  department_code: '',
  start_date: null,
  end_date: null
}

const state = {
  userInfo,
  searchData
}

export default state



// WEBPACK FOOTER //
// ./src/store/states.js